import { BoxProps, Text } from '@pancakeswap/uikit'
import { NodeRound } from 'state/types'
import { useTranslation } from '@pancakeswap/localization'
import { getRoundPosition } from '../../helpers'
import { LockPriceRow, PrizePoolRow, RoundPrice, RoundResultBox } from './styles'

interface RoundResultProps extends BoxProps {
  round: NodeRound
  hasFailed?: boolean
}

const RoundResult: React.FC<React.PropsWithChildren<RoundResultProps>> = ({
  round,
  hasFailed = false,
  children,
  ...props
}) => {
  const { lockPrice, closePrice, totalAmount } = round
  const betPosition = getRoundPosition(lockPrice, closePrice)
  const { t } = useTranslation()

  return (
    <RoundResultBox betPosition={betPosition} {...props} style={{ height: 'auto' }}>
      <Text color="white" fontSize="14px" mb="8px">
        {t('Closed Price')}
      </Text>
      {hasFailed ? (
        <Text bold textTransform="uppercase" color="textDisabled" mb="16px" fontSize="14px">
          {t('Cancelled')}
        </Text>
      ) : (
        <RoundPrice lockPrice={lockPrice} closePrice={closePrice} />
      )}
      {lockPrice && <LockPriceRow lockPrice={lockPrice} mb="16px" />}
      <PrizePoolRow totalAmount={totalAmount} />
      {children}
    </RoundResultBox>
  )
}

export default RoundResult
